module.exports = __webpack_public_path__ + "img/banner-1.9ab01453.png";